import Swiper from "swiper";
import { Scrollbar } from "swiper/modules";

const MobileSlider = ($) => {
	let $swiperSelector = $(".swiper-container");

	$swiperSelector.each(function (index) {
		let $this = $(this);
		$this.addClass("swiper-slider-" + index);

		let watchOverflow = $this.data("watch-overflow")
			? $this.data("watch-overflow")
			: true;

		new Swiper(".swiper-slider-" + index, {
			modules: [Scrollbar],
			direction: "horizontal",
			loop: false,
			freeMode: false,
			observer: true,
			observeParents: true,
			centeredSlides: false,
			watchOverflow: watchOverflow,
			spaceBetween: 24,
			slidesPerView: "auto",
			scrollbar: {
				el: ".swiper-scrollbar",
				draggable: true,
				dragSize: "auto",
			},
		});
	});
};

export default MobileSlider;
